import { TFunction } from 'i18next'
import { OrganizationType } from 'types/organization'
import { z } from 'zod'

export const createVideoSchema = (t: TFunction) =>
  z.object({
    title: z.string().min(1, {
      message: t('required'),
    }),
    description: z.string().min(1, {
      message: t('required'),
    }),
    videoUrl: z.string().url({ message: t('invalidUrl') }),
    ordinal: z.number(),
    audienceOrganizationType: z.enum([
      OrganizationType.CLIENT,
      OrganizationType.TENDER_AUTHORITY,
    ]),
    instructionFileId: z.string(),
  })
